import React, { useState } from "react";
import { Icons } from "./icons.jsx";
import { Pill, ActionButton, GuruAvatar } from "./primitives.jsx";
import HoverVideoArt from "./HoverVideoArt.jsx";
import {
  SpotlightCardRoot,
  SpotlightVideoWrap,
  SpotlightVideoInner,
  SpotlightBody,
  SpotlightPillRow,
  SpotlightTitle,
  SpotlightBlurb,
  SpotlightOutcome,
  SpotlightGuruRow,
  SpotlightGuruText,
  SpotlightGuruName,
  SpotlightGuruRole,
  SpotlightStats,
  SpotlightStatItem,
  SpotlightActions,
} from "./style.js";

// ── SpotlightCard ─────────────────────────────────────────────────────────────
const SpotlightCard = ({
  program,
  playToken,
  onAskPlay,
  onPreview,
  onOpen,
}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <SpotlightCardRoot
      className="mp-spotlight-card"
      $hovered={hovered}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onOpen(program)}
    >
      <SpotlightVideoWrap>
        <SpotlightVideoInner>
          <HoverVideoArt
            fillHeight
            program={program}
            hovered={hovered}
            playToken={playToken}
            onAskPlay={onAskPlay}
          />
        </SpotlightVideoInner>
      </SpotlightVideoWrap>
      <SpotlightBody>
        <SpotlightPillRow>
          <Pill tone="success" size="sm">
            <Icons.flame size={12} /> Most loved
          </Pill>
        </SpotlightPillRow>
        <SpotlightTitle>{program.name}</SpotlightTitle>
        <SpotlightBlurb>{program.description || program.short_description || ""}</SpotlightBlurb>
        <SpotlightOutcome>
          <Icons.zap size={16} style={{ color: "#01ECFF" }} />
          {program.featured_stat_text}
        </SpotlightOutcome>
        <SpotlightGuruRow>
          <GuruAvatar
            src={program.guru?.photo}
            name={program.guru?.full_name}
            size={36}
            ring={(program.accent ?? ["#01ECFF"])[0]}
          />
          <SpotlightGuruText>
            <SpotlightGuruName>
              Hosted by {program.guru?.full_name}
            </SpotlightGuruName>
            <SpotlightGuruRole>{program.guru?.role}</SpotlightGuruRole>
          </SpotlightGuruText>
        </SpotlightGuruRow>
        <SpotlightStats>
          {[
            [<Icons.clock size={14} />, program.duration],
            [<Icons.book size={14} />, `${program.lesson_count} Skill Development Sessions`],
            [
              <Icons.users size={14} style={{ color: "currentColor" }} />,
              `${program.sim_count} Simulation Challenges`,
            ],
            [<Icons.star size={14} />, program.rating],
          ].map(([icon, val], i) => (
            <SpotlightStatItem key={i}>
              {icon}
              {val}
            </SpotlightStatItem>
          ))}
        </SpotlightStats>
        <SpotlightActions>
          <ActionButton
            variant="primary"
            size="md"
            icon={<Icons.zap size={14} />}
            onClick={(e) => {
              e.stopPropagation();
              onPreview(program);
            }}
          >
            Start for Free
          </ActionButton>
          <ActionButton
            variant="purpleOutline"
            size="md"
            iconRight={<Icons.arrowRight size={14} />}
            onClick={(e) => {
              e.stopPropagation();
              onOpen(program);
            }}
          >
            Explore program
          </ActionButton>
        </SpotlightActions>
      </SpotlightBody>
    </SpotlightCardRoot>
  );
};

export default SpotlightCard;
